exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@-webkit-keyframes spinAnim {\n100% {\n        -webkit-transform: rotate(360deg);\n                transform: rotate(360deg)\n}\n}\n@keyframes spinAnim {\n100% {\n        -webkit-transform: rotate(360deg);\n                transform: rotate(360deg)\n}\n}\n.spinner {\n    -webkit-transform-origin: center;\n        -ms-transform-origin: center;\n            transform-origin: center;\n    -webkit-animation: spinAnim .75s infinite linear;\n            animation: spinAnim .75s infinite linear\n}\n", ""]);

// exports
